import { getTermValue, resetTerms } from '../../../../../packages/JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { KITCHEN_STOVE_MAP_VALUE_TO_LABEL } from './constants';

const ID = 'kitchenStove' as const;

export const kitchenStoveTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const kitchenStove = getTermValue('kitchen_stove')(jsonQuery);

    return kitchenStove
      ? [{ label: KITCHEN_STOVE_MAP_VALUE_TO_LABEL[kitchenStove], value: createTagValue(ID, kitchenStove) }]
      : null;
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['kitchen_stove'])(jsonQuery),
};
